var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home_wrap"},[_c('van-nav-bar',{attrs:{"title":_vm.title,"left-text":"","left-arrow":"","fixed":true},on:{"click-left":_vm.onClickLeft}}),_c('div',{staticClass:"art",domProps:{"innerHTML":_vm._s(_vm.content)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }